import { render } from "./editfolderpopup.vue?vue&type=template&id=505f3ee5&scoped=true"
import script from "./editfolderpopup.js?vue&type=script&lang=js"
export * from "./editfolderpopup.js?vue&type=script&lang=js"

import "./editfolderpopup.vue?vue&type=style&index=0&id=505f3ee5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505f3ee5"]])

export default __exports__